import { onMounted, onUnmounted } from 'vue'
import { EventBus } from '@/common/utils/event-bus'
import { EVENT_TYPE, ON_DISPLAY_BAND } from '@/common/resources/const'

export const useEventOnDisplay = (dom = null, sectionInfo = {}) => {
  const ROOT_MARGIN = '50px'
  let observer = null

  const sendEvent = () => {
    const onDisplayEvent = sectionInfo?.eventlist.find(
      (e) => e?.type === EVENT_TYPE.ON_DISPLAY,
    )
    if (onDisplayEvent) {
      EventBus.$emit(ON_DISPLAY_BAND, onDisplayEvent)
    }
  }

  const createObserver = (element) => {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            sendEvent()
          }
        })
      },
      {
        root: null,
        rootMargin: ROOT_MARGIN,
        threshold: 0,
      },
    )

    observer.observe(element)
  }

  onMounted(() => {
    const element = dom?.value
    const hasEvent =
      Array.isArray(sectionInfo?.eventlist) &&
      sectionInfo?.eventlist?.some((e) => e?.type === EVENT_TYPE.ON_DISPLAY)

    if (element && hasEvent) {
      createObserver(element)
    }
  })

  onUnmounted(() => {
    observer.disconnect()
    observer = null
  })
}
